import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';
import history from '../../history';
import { STATUS } from '../../utils/status';
import { calculateWin } from '../CreateStake/OddsSlider';
import { updateStake } from '../../firebase';
import { updateUserBalanceAction } from '../rootReducer';

import ViewStake from './ViewStake';

class LiveStake extends Component {
  static propTypes = {
    stake: PropTypes.object.isRequired
  };

  state = {
    isLoading: false
  };

  concedeStake = () => {
    this.setState({ isLoading: true });
    const stake = { ...this.props.stake };
    stake.status = STATUS.Settled;
    stake.winner = stake.isMyStake ? stake.stakee : stake.stakerId;

    // Winner takes entire pot
    const winner = this.props.users.find(x => x.user_id === stake.winner);
    const totalWin = calculateWin(stake.amount, stake.odds) + stake.amount;
    
    updateStake(stake, this.props.stake.id)
      .then(() => {
        this.props.updateUserBalanceAction(totalWin, winner.user_id);
      });

    history.push('/');
  };  

  claimStake = () => {
    this.setState({ isLoading: true });
    const stake = { ...this.props.stake };
    stake.status = STATUS.Claimed;
    stake.playerClaiming = stake.isMyStake ? stake.stakerId : stake.stakee;

    updateStake(stake, this.props.stake.id);
    history.push('/');
  };
  
  cancelStake = () => {
    this.setState({ isLoading: true });
    const stake = { ...this.props.stake };
    stake.status = STATUS.RequestCancel;
    stake.playerRequesting = stake.isMyStake ? stake.stakerId : stake.stakee;

    updateStake(stake, this.props.stake.id);
    history.push('/');
  };

  render() {
    const { isLoading } = this.state;
    let { stake } = this.props;

    return (
      <ViewStake
        stake={stake}
        actions={
          <div>
            <Button fluid positive size="large" loading={isLoading} disabled={isLoading} onClick={this.claimStake}>
              Claim
            </Button>
            <div className="equal-width">
              <Button fluid color="grey" size="large" loading={isLoading} disabled={isLoading} onClick={this.cancelStake}>
                Cancel
              </Button>
              <Modal
                size="mini"
                trigger={
                  <Button fluid negative size="large" loading={isLoading} disabled={isLoading}>
                    Concede
                  </Button>
                }
                header="Concede Stake"
                content="Are you sure you want to concede the stake?"
                actions={['No', { key: 'concede', content: 'Concede', negative: true, onClick: this.concedeStake }]}
              />
            </div>
          </div>
        }
      />
    );
  }
}

const mapStateToProps = ({ app }) => ({
  availableBalance: app.availableBalance,
  users: app.users
});

export default connect(mapStateToProps, { updateUserBalanceAction })(LiveStake);



// WEBPACK FOOTER //
// ./src/App/ViewStake/LiveStake.js